import { getObject } from 'larasnap/support';

export default class {
    _row;

    constructor(row) {
        this._row = row;
    }

    getId() {
        return this._row.id;
    }

    getField(name) {
        return getObject(this._row.fields, name);
    }

    getFields() {
        return this._row.fields;
    }

    getCell(index) {
        return this._row.cells[index];
    }

    getCells() {
        return this._row.cells;
    }
}
